module.exports = __webpack_public_path__ + "img/20220824134617311e2z.c5b6ab30.png";